import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import DraftFlow               from '@draft/draft-flow';
import DraftManagementModal    from '@draft/draft-header-management';
import DraftSecretSettingModal from '@draft/draft-secret-setting-modal';
import Card                    from '@common/influencer/_card';

// -------------------------------------------------------


class Draft extends React.Component {
  change() {
    let draft_code = null;
    
    this.props.detail.all_draft.map((d) => {
      if( d.id == this.draft_id.value) draft_code = d.unique_id;
    });
    
    if( draft_code == null ){
      alert('エラーが発生しました。管理者に問い合わせください');
    } else {
      console.log(draft_code);
      location.href = '/draft/'+ draft_code;
    }
    //this.props.change_ev.bind(this)(this.draft_id.value);
    //location.href = '/draft/'+ res.body.new_draft_code;
  }
  // -------------------------------------------------------
  
  create() {
    let detail = this.props.detail;
    
    let chk = confirm('インフルエンサーの新しいバージョンの代わりに作成します。\n（通常のフローとは異なる手順になりますご注意ください）');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/draft/create', { project_id: this.props.data.project.id, insta_user_id: detail.insta_user_id },
      function(res){
        //this.props.change_ev.bind(this)(res.body.new_draft_id);
        location.href = '/draft/'+ res.body.new_draft_code;
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  setDraftFlow(value, mode, flow_no, option) {
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/draft/set_draft_flow', { value: value, mode: mode, flow_no: flow_no, project_id: this.props.data.project.id, insta_user_id: detail.insta_user_id, draft_id: this.props.detail.id, option: option },
      function(res){
        this.props.refresh_ev.bind(this)(this.props.detail.id);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  setTemplateDraftFlow() {
    let chk = confirm('現在の設定内容を破棄して、プロジェクトのテンプレートを適用してもよろしいですか？');
    if( chk == false ) return;
    
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/draft/set_draft_flow_template', {  project_id: this.props.data.project.id, insta_user_id: detail.insta_user_id, draft_id: this.props.detail.id },
      function(res){
        this.props.refresh_ev.bind(this)(this.props.detail.id);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let detail = this.props.detail;
    
    // 下書きフローのテンプレート
    let draft_flow_template = [];
    try { draft_flow_template = JSON.parse(this.props.data.project.detail.draft_flow_template); } catch(e) {}
    if( draft_flow_template == null ) draft_flow_template = [];
    
    return (
      <div className="draft-header">
        <div className="main-header">
          <div className="title">
            <span>下書き確認</span>{data.project.title}
            {/*(detail.is_secret_mode === true) && <b className="is-secret-mode">[共通ログイン]</b>*/}
          </div>
          
          <DraftManagementModal detail={detail} change_ev={this.change.bind(this)} />
          
          { ( detail.my_authority !== 0 ) && 
            <div className="draft-date">
              <h6>下書き提出日</h6>
              <div className="selectbox">
                <select ref={(input) => { this.draft_id = input }} onChange={this.change.bind(this)} defaultValue={data.draft.id}>
                  { detail.all_draft.map((d, key) => {
                    return <option key={key} value={d.id}>Ver.{d.version} ({Moment(d.create_date).format('YYYY年M月D日')})</option>
                   })}
                </select>
              </div>
              
              { (detail.is_admin === true) && <p className="new-version" onClick={this.create.bind(this)}>新しいバージョンを作成</p> }
            </div>
          }
        </div>
        
        <div className="sub-header">
          <div className="header-profile">
            <div className="influencer-profile">
              <Card data={data.influencer} option={['is_not_info']} />
              
              <div className="user-name">
                <h5>@{data.influencer.insta_id}</h5>
                <h3>{data.influencer.full_name}</h3>
              </div>
            </div>
          </div>
          
          <div className="header-management">
            { ( detail.my_authority !== 0 ) &&
              <DraftFlow 
                data={data}
                detail_id={detail.id}
                draft_flow={detail.draft_flow}
                flow_no={detail.flow_no}
                members={detail.company_members}
                is_edit={(detail.my_authority == 99 && (detail.complete == 0 || detail.is_submission == 0))}
                management={data.management}
                is_complete={detail.is_user_complete}
                set_ev={this.setDraftFlow.bind(this)}
                refresh_ev={this.props.refresh_ev.bind(this)}
                template_ev={(draft_flow_template.length > 0) ? this.setTemplateDraftFlow.bind(this) : null}
              />
            }
            
            { ( detail.my_authority === 0 && Object.keys(detail.draft_flow).length > 0 ) &&
              <DraftSecretSettingModal
                data={data}
                item={detail.draft_flow}
                detail_id={data.draft.id}
                is_guest_mode={true}
                is_secret_mode={this.props.is_secret_mode}
                refresh_ev={this.props.refresh_ev.bind(this)}
              />
            }
          </div>
        </div>
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Draft;